export default __webpack_public_path__ + "static/media/mauquenchy4.3e70e99f.jpg";